import styled from 'styled-components';
import {em, transparentize} from 'polished';

export const Label = styled.label`
    font-family: ${({theme}) => theme.font?.family?.primary};
    display: inline-flex;
    align-items: center;
    text-transform: uppercase;
    padding-right: 0.75em;
    font-weight: 900;
    font-size: ${em(14, 16)};
`;

export const LabelText = styled.span`
    transition: color 0.2s ease-in-out;
    color: ${({theme}) => theme.color?.label};
`;

export interface RadioInputProps {
    $hasLabel?: boolean;
    $color?: string;
}

export const RadioInput = styled.input.attrs(() => ({type: 'radio'}))<RadioInputProps>`
    appearance: none;
    outline: none;
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin: ${({$hasLabel}) => ($hasLabel ? 'auto 5px auto auto' : 'auto')};
    position: relative;

    &::before,
    &::after {
        content: '';
        position: absolute;
        display: block;
        transition: background-color 0.2s ease-in-out;
        border-radius: 50%;
        box-sizing: border-box;
    }

    &::before {
        width: 100%;
        height: 100%;
        background-color: ${({theme}) => theme.color?.background};
        border: 1px solid ${({theme}) => theme.color?.label};
    }

    &::after {
        top: 20%;
        left: 20%;
        width: 60%;
        height: 60%;
        background-color: transparent;
    }

    &:checked::before {
        border: 1px solid ${({$color, theme}) => $color || theme.color?.primary};
        background-color: ${({$color, theme}) => transparentize(0.85, $color || (theme.color?.primary as string))};
    }

    &:checked::after {
        background-color: ${({$color, theme}) => $color || theme.color?.primary};
    }

    &:checked + ${LabelText} {
        color: ${({theme, $color}) => $color || theme.color?.primary};
    }
`;
